import React, { useState, useEffect } from 'react';
import {
    Segment,
    Sidebar,
    Menu,
    Visibility,
    Container,
    Icon,
    Image,
} from 'semantic-ui-react';
import { logout, getUser } from 'src/libraries/auth.library';
import { checkVisibility } from '../../libraries/access.library';
import {
    ORGHeader,
    MOLUserAgent,
    MOLIdleTime,
    ATMResponsive,
} from 'shared-it-appmod-ui';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Navigation from 'src/components/pages/navigation/navigation.component';
import Logo from 'src/assets/images/sempra_logo.png';
import Lang from 'src/libraries/language';
import style from 'src/layouts/private/private.module.scss';
import { AccessRole } from 'src/constants/access.constant';
import ToasterContainer from 'src/components/atoms/toaster/toaster.component';
import SystemMessageComponent from 'src/components/organisms/system-message/system-message.component';
import FooterComponent from 'src/components/organisms/footer/footer.component';
import { routes } from 'src/router';

import {
    PRIME_LOGIN_REDIRECT_URL,
    CONTACT_LOGIN_REDIRECT_URL,
} from 'src/constants';

interface AppProps {
    children?: React.ReactNode;
}

const DesktopContainer: React.FC<AppProps> = ({ children }) => {
    const [fixed, setFixed] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const user = getUser();
    if (fixed) {
        // TODO
    }
    if (
        location.pathname === '/' ||
        location.pathname === '/resetpassword' ||
        location.pathname === '/proxy' ||
        location.pathname === '/login' ||
        location.pathname === '/error' ||
        location.pathname === '/success' ||
        location.pathname === '/primelogin'
    ) {
        return (
            <>
                <ToasterContainer />
                <div style={{ maxWidth: '1920px', margin: '0 auto' }}>
                    <ATMResponsive greaterThan="mobile">
                        {children}
                    </ATMResponsive>
                </div>
            </>
        );
    } else {
        return (
            <>
                <ATMResponsive greaterThan="mobile">
                    <Visibility
                        once={false}
                        onBottomPassed={() => setFixed(true)}
                        onBottomPassedReverse={() => setFixed(false)}
                    >
                        <div className={style.contentWrapper}>
                            <ToasterContainer />
                            <SystemMessageComponent />

                            <ORGHeader
                                //logoName="sdge"
                                homeLink={
                                    user != null &&
                                    user.user_group == AccessRole.PRIME
                                        ? PRIME_LOGIN_REDIRECT_URL
                                        : CONTACT_LOGIN_REDIRECT_URL
                                }
                                location={location}
                                handleLocation={navigate}
                                application={Lang.TTL_APPLICATION}
                                environment={process.env.REACT_APP_ENVIRONMENT}
                                menuCount={9}
                                showHelp={false}
                                menus={routes
                                    .filter(
                                        (value) =>
                                            value.title &&
                                            checkVisibility(value.access_role)
                                    )
                                    .map((route) => {
                                        return {
                                            name: route.title,
                                            to: route.path,
                                        };
                                    })}
                                user={
                                    user?.first_name
                                        ? { username: `Hi, ${user.first_name}` }
                                        : undefined
                                }
                                onLogout={() => logout()}
                            >
                                <div
                                    className={style.wrapper}
                                    style={{
                                        maxWidth: '98%',
                                        margin: '0 auto',
                                    }}
                                >
                                    <Outlet />
                                </div>
                            </ORGHeader>
                            <FooterComponent />
                        </div>
                    </Visibility>
                </ATMResponsive>
            </>
        );
    }
};

const MobileContainer: React.FC<AppProps> = ({ children }) => {
    const location = useLocation();
    const [sidebarOpened, setSidebarOpened] = useState(false);
    if (location.pathname === '/') {
        return <ATMResponsive media="mobile">{children}</ATMResponsive>;
    } else {
        return (
            <ATMResponsive media="mobile">
                <Sidebar
                    as={Menu}
                    animation="push"
                    inverted
                    onHide={() => setSidebarOpened(false)}
                    vertical
                    visible={sidebarOpened}
                >
                    <Navigation />
                </Sidebar>

                <Sidebar.Pusher dimmed={sidebarOpened}>
                    <Segment inverted textAlign="center" vertical>
                        <Container>
                            <Menu inverted pointing secondary size="large">
                                <Menu.Item
                                    onClick={() => setSidebarOpened(true)}
                                >
                                    <Icon name="sidebar" />
                                </Menu.Item>
                                <Menu.Item className={style.brand}>
                                    <Image src={Logo} centered />
                                </Menu.Item>
                            </Menu>
                        </Container>
                    </Segment>

                    {children}
                </Sidebar.Pusher>
            </ATMResponsive>
        );
    }
};

const MasterLayout: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const user = getUser();

    const idleTimeInMinutes: number = parseFloat(
        process.env.REACT_APP_IDLE_TIME_IN_MINUTES ?? ''
    );

    useEffect(() => {
        if (
            user == null &&
            (window.location.pathname == '/proxy' ||
                window.location.pathname == '/login' ||
                window.location.pathname == '/error' ||
                window.location.pathname == '/success' ||
                window.location.pathname == '/primelogin' ||
                window.location.pathname == '/resetpassword')
        ) {
            return;
        } else if (user == null) {
            navigate('/');
        }
    }, [user]);

    return (
        <div>
            {
                <MOLUserAgent /> // for browsers notification
            }
            <DesktopContainer>
                <Outlet />
            </DesktopContainer>
            <MobileContainer>
                <Outlet />
            </MobileContainer>
            {location.pathname != '/' &&
                location.pathname != '/primelogin' &&
                location.pathname != '/resetpassword' &&
                user != null && (
                    <MOLIdleTime
                        timeout={idleTimeInMinutes} //popup for idle time
                        onLogout={() => {
                            logout();
                        }}
                    />
                )}
        </div>
    );
};

export default MasterLayout;
